<template>
  <div class="flex flex-col gap-6 z-1000 w-full h-full">
    <loading-overlay v-if="loading" :value="loading" />
    <div v-else class="block-container">
      <BaseTabs :tabs="tabs" :active-tab="activeTab" @change:tab="changeTab">
        <template #action>
          <div
            v-if="$route.name !== 'tariff_item_view'"
            class="flex items-center gap-2"
          >
            <el-tooltip
              v-if="$route.name !== 'tariff_new'"
              :content="$t('Режим просмотра')"
              placement="top"
            >
              <Button variant="outline" size="icon" @click="goToView">
                <svg-icon name="huge-eye" class="w-4 h-4 text-foreground" />
              </Button>
            </el-tooltip>
            <Button variant="default" :disabled="loader" @click="submitForm">
              {{ $t("Сохранить") }}
            </Button>
          </div>
          <div v-else class="flex items-center gap-3">
            <Button variant="outline" size="icon" @click="goToEdit">
              <svg-icon name="huge-edit" class="w-4 h-4 text-foreground" />
            </Button>
          </div>
        </template>
      </BaseTabs>
    </div>

    <component
      :is="currentTabComponent"
      :form="form"
      :selectedTariff="selected_tariff"
      ref="activeForm"
      class="flex-1 w-full h-full"
    />
  </div>
</template>

<script>
import LoadingOverlay from "@/shared/ui/custom/components/LoadingOverlay.vue";
import BaseTabs from "@/shared/ui/custom/tabs/BaseTabs.vue";
import TariffData from "./tabs/TariffData.vue";
import Button from "@/shared/ui/button/Button.vue";

import { getTariffItem, updateTariff, createTariff } from "@/entities/tariff";

export default {
  name: "TariffItem",
  components: {
    LoadingOverlay,
    BaseTabs,
    TariffData,
    Button,
  },

  data() {
    return {
      loading: false,
      loader: false,
      activeTab: "data",
      selected_tariff: null,

      showHiddenConflictDialog: false,
      hiddenConflictData: null,

      form: {
        codes: [],
        name: "",
        name_kz: "",
        value: "",
        participant_type: "OTHER",
        locality: "ALL",
        amount_from: 0,
        amount_to: 999999,
        type_calculation: "MRP",
        relatives: false,
        extra_names: {},
        hidden_fields: [],
      },
    };
  },

  computed: {
    uuid() {
      return this.$route.params.id;
    },
    tabs() {
      return {
        data: {
          label: this.$t("Параметры тарифа"),
        },
      };
    },
    currentTabComponent() {
      const tabComponents = {
        data: TariffData,
      };

      return tabComponents[this.activeTab] || null;
    },
  },
  watch: {
    "$route.name"() {
      if (this.uuid && this.uuid !== "new") {
        this.getTariffItem();
      }
    },
  },

  async created() {
    if (this.uuid && this.uuid !== "new") {
      await this.getTariffItem();
    }
  },

  methods: {
    async getTariffItem() {
      this.loading = true;
      try {
        const data = await getTariffItem(this.uuid);
        if (data?.success) {
          this.selected_tariff = data.payload;
          this.form = { ...data.payload };
        }
      } finally {
        this.loading = false;
      }
    },
    changeTab(tab) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          tab,
        },
      });
    },
    goToView() {
      this.$router.push({
        name: "tariff_item_view",
        params: { id: this.uuid },
      });
    },
    goToEdit() {
      this.$router.push({
        name: "tariff_item",
        params: { id: this.uuid },
      });
    },
    handleActions() {},
    async submitForm() {
      const formRef = this.$refs.activeForm;

      if (!formRef?.validate) return;

      const valid = await formRef.validate();

      if (!valid) {
        console.warn("❌ Validation failed");
        return;
      }

      const payload = { ...this.form };

      if (!payload.extra_names) {
        payload.extra_names = {};
      }

      if (this.uuid && this.uuid !== "new") {
        await this.updateTariff(payload);
      } else {
        await this.createTariff(payload);
      }
    },
    async createTariff(payload) {
      this.loader = true;

      try {
        const data = await createTariff(payload);

        if (data.success && data.payload?.id) {
          this.$router.push({
            name: "tariff_item_view",
            params: { id: data.payload.id },
          });
        }
      } finally {
        this.loader = false;
      }
    },
    async updateTariff(payload) {
      this.loader = true;

      try {
        const data = await updateTariff(this.uuid, payload);

        if (data.success) {
          this.$router.push({
            name: "tariff_item_view",
            params: { id: this.uuid },
          });
        }
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  @apply h-10 flex justify-center items-center p-4 bg-card border;
  @apply border-border rounded outline-none;
  &:active {
    transform: scale(0.98);
  }
}

.menu {
  @apply w-[282px] flex flex-col p-2 gap-2 bg-card rounded-xl outline outline-1 outline-offset-[-1px];
}

.item {
  @apply flex items-center px-3 py-2 gap-3 rounded-lg cursor-pointer transition-colors;
  svg {
    @apply text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }

  span {
    @apply text-base font-medium leading-6 text-foreground;
    &.danger {
      @apply text-red-400;
    }
  }
}
</style>
